import { render, staticRenderFns } from "./resultDialog.vue?vue&type=template&id=05cf5655&scoped=true"
import script from "./resultDialog.vue?vue&type=script&lang=js"
export * from "./resultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf5655",
  null
  
)

export default component.exports